import React from 'react';
import { formatTimeForDisplay } from '../../Surveys/TimeSelectField';

export default function TimeCell({ value, column }) {
  if (!value) return <span />;

  const display = formatTimeForDisplay(value, column.custom_format);
  return <span>{display}</span>;
}
